import { SectionCard } from '../../components/Section';
import MicrosoftBadge from '../../assets/img/microsoft-365-certified-fundamentals.png';
import AWSDeveloperBadge from '../../assets/img/aws-certified-developer-associate.png';
import AWSDevOpsProfessionalBadge from '../../assets/img/aws-certified-devops-engineer-professional.png';
import './Certifications.scss';

const Certifications = (props) => {
  return (
    <SectionCard heading="Certifications">
      <div className="certification">
        <div className="certification__badge">
          <img src={AWSDevOpsProfessionalBadge} alt="AWS DevOps Engineer Professional badge" />
        </div>
        <h4 className="certification__heading">
          AWS Certified DevOps Engineer Professional
          <span className="certification__year">2026</span>
        </h4>
      </div>
      <div className="certification">
        <div className="certification__badge">
          <img src={AWSDeveloperBadge} alt="AWS Certified Developer Associate badge" />
        </div>
        <h4 className="certification__heading">
          AWS Certified Developer Associate
          <span className="certification__year">2025</span>
        </h4>
      </div>
      <div className="certification">
        <div className="certification__badge">
          <img src={MicrosoftBadge} alt="Microsoft 365 certification badge" />
        </div>
        <h4 className="certification__heading">
          Microsoft 365 Certified: Fundamentals
          <span className="certification__year">2022</span>
        </h4>
      </div>
    </SectionCard>
  );
};
export default Certifications;
